<div class="ui-g form-container" style="height: 500px;">
  <form [formGroup]="publishOpenShift">
    <div class="ui-g-12">
      <h2 class="page-header-c popup-header" translate>label_publish_open_shift
      </h2>
    </div>

    <div class="ui-g-12">
      <div class="ui-g">
        <div class="ui-g-12  ui-md-12 ui-lg-12 ui-g-nopad mb-r">
          <div class="ui-g">
            <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
              <div class="form-label">
                <label translate>label_open_shift_for</label>
                <label class="asterisk">*</label>
              </div>
              <div class="form-control-c">
                <p-radioButton *ngIf="showTeamRadioButton" name="openShiftFor" class="label-txt" (onClick)="isIndividualYes(true)"
                  formControlName="isIndividual" value="true" label="&nbsp;Team"></p-radioButton>
                <p-radioButton name="openShiftFor" class="label-txt" (onClick)="isIndividualNo(false)" *ngIf="globalConfigMSFWPU"
                    formControlName="isIndividual" value="false" label="&nbsp;Individual" 
                   ></p-radioButton>
              </div>
              <div class="form-errors"
                *ngIf="publishOpenShift.controls.isIndividual.errors  && (publishOpenShift.controls.isIndividual.dirty || publishOpenShift.controls.isIndividual.touched)">
                <div [hidden]="!publishOpenShift.controls.isIndividual.errors.required" translate>
                  label_open_shift_required
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-6 ui-lg-6" *ngIf="isIndividual">
          <div class="form-label">
            <label for="" translate>label_open_shift_team</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control-c">
            <p-dropdown autocomplete="off" [options]="teamList" [defaultLabel]="'Select Team' | translate"
              (onChange)="onChangemarketTeam($event,6)" [style]="{'width': '100%'}" filter="filter"
              [resetFilterOnHide]="true" formControlName="team" [style]="{'width': '100%'}">
            </p-dropdown>
          </div>
          <div class="form-errors"
            *ngIf="publishOpenShift.controls.team.errors  && (publishOpenShift.controls.team.dirty || publishOpenShift.controls.team.touched)">
            <div [hidden]="!publishOpenShift.controls.team.errors.required" translate>
              label_open_shift_team_required
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-6 ui-lg-6" *ngIf="isIndividual">
          <div class="form-label">
            <label for="" translate>label_open_shift_applications</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control-c">
            <input class="num-inp" autocomplete="off" maxlength="1"
              oninput="this.value = this.value.charAt(0).toUpperCase() + this.value.substr(1)" type="text" pInputText
              formControlName="applications" [placeholder]="'Applications' | translate"
              (keypress)="onKeypress($event)" />
          </div>
          <div class="form-errors"
            *ngIf="publishOpenShift.controls.applications.errors  && (publishOpenShift.controls.applications.dirty || publishOpenShift.controls.applications.touched)">
            <div [hidden]="!publishOpenShift.controls.applications.errors.required" translate>
              label_open_shift_applications_required
            </div>
            <div [hidden]="!publishOpenShift.controls.applications.errors.minlength" translate>
              min_length_1
            </div>
            <div [hidden]="!publishOpenShift.controls.applications.errors.maxlength" translate>
              max_number_1
            </div>
            <div [hidden]="!publishOpenShift.controls.applications.errors.pattern" translate>
              name_pattern
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-12 ui-lg-12" *ngIf="!isIndividual">
          <div class="form-label">
            <label for="" translate>label_open_shift_applications</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control-c">
            <input autocomplete="off" oninput="this.value = this.value.charAt(0).toUpperCase() + this.value.substr(1)"
            maxlength="1" type="text" pInputText formControlName="applications" [placeholder]="'Applications' | translate" (keypress)="onKeypress($event)" />
          </div>
          <div class="form-errors"
            *ngIf="publishOpenShift.controls.applications.errors  && (publishOpenShift.controls.applications.dirty || publishOpenShift.controls.applications.touched)">
            <div [hidden]="!publishOpenShift.controls.applications.errors.required" translate>
              label_open_shift_applications_required
            </div>
            <div [hidden]="!publishOpenShift.controls.applications.errors.minlength" translate>
              min_length_1
            </div>
            <div [hidden]="!publishOpenShift.controls.applications.errors.maxlength" translate>
              max_number_1
            </div>
            <div [hidden]="!publishOpenShift.controls.applications.errors.pattern" translate>
              name_pattern
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
          <div class="form-label">
            <label translate>label_open_shift_shift_date</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control-c">
            <p-calendar formControlName="shiftDate" [defaultDate]="minDate" [showIcon]="true"
              dateFormat="{{dateFormat}}" [placeholder]="'Shift Date'" [minDate]="minDate" [maxDate]="maxDate"
              (onSelect)="changeTeamListDate($event)">
            </p-calendar>
          </div>
          <div class="form-errors"
            *ngIf="publishOpenShift.controls.shiftDate.errors  && (publishOpenShift.controls.shiftDate.dirty || publishOpenShift.controls.shiftDate.touched)">
            <div [hidden]="!publishOpenShift.controls.shiftDate.errors.required" translate>
              label_open_shift_shift_date_required
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
        </div>
        <div class="form-field ui-g-12 ui-md-12 ui-lg-12 mult-elip mb-r" *ngIf="isIndividual">
          <div class="form-label">
            <label for="" translate>label_open_shift_shift_team_members</label>
            <!-- <label class="asterisk">*</label> -->
          </div>
          <div class="form-control-c">
            <p-multiSelect  autocomplete="off" [options]="providerTeamMembersList" [disabled]="teamId === ''"
              [defaultLabel]="'Select' | translate" formControlName="teamMembers" [style]="{'width': '100%'}"
              filter="filter" [resetFilterOnHide]="true" (onChange)="onMarketSelect($event)">
            </p-multiSelect>
          </div>
          <div class="form-errors"
            *ngIf="publishOpenShift.controls.teamMembers.errors  && (publishOpenShift.controls.teamMembers.dirty || publishOpenShift.controls.teamMembers.touched)">
            <div [hidden]="!publishOpenShift.controls.teamMembers.errors.required" translate>
              label_open_shift_shift_team_members_required
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
          <div class="form-label">
            <label translate>label_open_shift_shift_time</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control-c">
            <p-calendar class="schedule-calender-timer" formControlName="startTime" [showIcon]="true" hourFormat="12"
              timeOnly="true" [stepMinute]="15" [placeholder]="'Start Time' | translate" icon="pi pi-clock" (onBlur)="startTimeValue()"
              (onSelect)="startTimeSelect($event)" (onBlur)="getTime($event)" [defaultDate]="currentDate">
            </p-calendar>
          </div>
          <div class="form-errors"
            *ngIf="publishOpenShift.controls.startTime.errors  && (publishOpenShift.controls.startTime.dirty || publishOpenShift.controls.startTime.touched)">
            <div [hidden]="!publishOpenShift.controls.startTime.errors.required" translate>
              label_open_shift_shift_time_required
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
          <div class="form-label">
            <label translate></label>
          </div>
          <div class="form-control-c">
            <p-calendar class="schedule-calender-timer" formControlName="endTime" [showIcon]="true" hourFormat="12"
              timeOnly="true" [stepMinute]="15" [placeholder]="'End Time' | translate" icon="pi pi-clock"
              (onSelect)="endTimeSelect($event)" (onBlur)="getEndTime($event)" [defaultDate]="currentDate">
            </p-calendar>
          </div>
          <div class="form-errors"
            *ngIf="publishOpenShift.controls.endTime.errors  && (publishOpenShift.controls.endTime.dirty || publishOpenShift.controls.endTime.touched)">
            <div [hidden]="!publishOpenShift.controls.endTime.errors.required" translate>
              label_open_shift_shift_end_time_required
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
          <div class="form-label">
            <label translate>label_open_shift_shift_notes</label>
          </div>
          <div class="form-control-c">
            <textarea [rows]="4" [cols]="30" maxlength="300" formControlName="notes" class="no-resize" [placeholder]="'Enter Notes' | translate"></textarea>

          </div>
        </div>

      </div>

      <div class="form-buttons ui-g-12 ui-g-nopad pt-20 pb-20">
        <button class="save-btn" pButton type="button" [label]="'Publish' | translate"
          [disabled]="doValidSave() || displaySaveButton" (click)="onClickPubilstShift()"></button>
        <button class="cancel-btn" pButton type="button" [label]="'label_cancel' | translate"
          (click)="cancelUserForm()"></button>
      </div>

    </div>
  </form>
</div>
